import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import AssignmentUnitsResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import { prefix } from "./constants.js";
import { resetUpdateResult } from "./actions.js";
import { replaceAssignmentUnit } from "../../common/epics/actions.js";
const updateAssignmentUnitEpicReducerArgs = {
  actionPrefix: `${prefix}/UPDATEV2`,
  reduxKeyNested: () => ["updateResult"],
  loadResource: (inputPayload) => AssignmentUnitsResource.updateAssignmentUnit(inputPayload.workspaceId, inputPayload.id, inputPayload.data),
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    replaceAssignmentUnit(outputPayload),
    resetUpdateResult()
  ]
};
const updateAssignmentUnitEpicReducer = loadResourcesUtils(updateAssignmentUnitEpicReducerArgs);
export {
  updateAssignmentUnitEpicReducer
};
//# sourceMappingURL=epicsV2.js.map
